import OwaSessionStore from './schema/OwaSessionStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { TraceableError } from 'owa-trace';
import { __resetGlobalContext } from 'satcheljs/lib/globalContext';

var initialStore: OwaSessionStore = {
    userConfiguration: {},
    connectedAccountsUserConfigurationMap: new ObservableMap({}),
    defaultFolderNameToIdMap: new ObservableMap({}),
    defaultFolderIdToNameMap: new ObservableMap({}),
};

let getStore: () => OwaSessionStore = <any>undefined;
let store: OwaSessionStore = <any>undefined;
try {
    getStore = createStore<OwaSessionStore>('owaSessionStore', initialStore);
    store = getStore();
} catch (e) {
    let info = 'success';
    try {
        __resetGlobalContext();
    } catch (satchelError) {
        info = satchelError ? satchelError.toString() : 'NoError';
    }

    (<TraceableError>e).diagnosticInfo = JSON.stringify({
        c: typeof createStore,
        g: typeof (window as any).__satchelGlobalContext,
        i: info,
        r: typeof __resetGlobalContext,
    });
    throw e;
}

export default store;
